import React from "react";
import styled from "styled-components";
import { DatePicker } from "react-rainbow-components";
import breakpoint from "../../assets/breakpoints";

const Container = styled.div`
  display: flex;
  margin-top: 0.5rem;
  width: 20rem;
  justify-content: space-between;
  @media only screen and ${breakpoint.device.sm} {
    width: 100%;
  }
`;

const DatePickerEditer = styled(DatePicker)`
  width: 9.5rem;
  @media only screen and ${breakpoint.device.sm} {
    flex: 1;
    margin: 0.5rem;
  }
`;

const CalendarRangePicker = (props: {
  initalDate?: (date: Date) => void;
  finaleDate?: (date: Date) => void;
}) => {
  const [initialDate, setInitialDate] = React.useState<Date>(
    new Date("2021-09-25")
  );
  const [finaleDate, setFinaleDate] = React.useState<Date>(new Date());

  const handleInitialDateChange = (date: Date) => {
    setInitialDate(date);
    props.initalDate && props.initalDate(date);
  };

  const handleFinaleDateChange = (date: Date) => {
    setFinaleDate(date);
    props.finaleDate && props.finaleDate(date);
  };

  return (
    <Container>
      <DatePickerEditer
        selectionType="single"
        label="ช่วงเวลาเริ่มต้น"
        placeholder="เริ่มต้น"
        formatStyle="medium"
        locale="th"
        minDate={new Date("2021-09-25")}
        maxDate={new Date()}
        value={initialDate}
        onChange={(e) => handleInitialDateChange(e)}
      />
      <DatePickerEditer
        selectionType="single"
        label="เวลาสิ้นสุด"
        placeholder="สิ้นสุด"
        formatStyle="medium"
        locale="th"
        minDate={initialDate}
        maxDate={new Date()}
        value={finaleDate}
        onChange={(e) => handleFinaleDateChange(e)}
      />
    </Container>
  );
};

export default CalendarRangePicker;
